import { CustomFieldInputComponent } from "../CustomFieldsForm";
import NumberTextField from "../../../common/NumberTextField";

const NumberCustomFieldInput: CustomFieldInputComponent = ({
  value,
  customFieldDefinition,
  onChange,
  label,
  disabled,
}) => {
  return (
    <NumberTextField
      onChange={(event) => {
        onChange(event.target.value === "" ? null : Number(event.target.value));
      }}
      value={String(value || "")}
      size="medium"
      fullWidth
      disabled={disabled}
      label={label || customFieldDefinition.label}
    />
  );
};

export default NumberCustomFieldInput;
